export const PACKAGE_CATEGORIES = [
  { key: "bodas", label: "Boda Fotografía" },
  { key: "foto_video", label: "Boda Foto + Video" },
  { key: "boda_civil", label: "Boda Civil" },
  { key: "xv", label: "XV Años" },
  { key: "album_impreso", label: "Álbum Impreso" },
  { key: "content_creator", label: "Content Creator" },
  { key: "bautizo", label: "Bautizo" },
  { key: "sesion", label: "Sesiones de Fotos" },
  { key: "save_the_date", label: "Save the Date" },
  { key: "invitacion_digital", label: "Invitación Digital" },
  { key: "cabina_fotos", label: "Cabina de Fotos" },
  { key: "podcast_boda", label: "Podcast de tu Boda" },
];

export const STEPS = ["Datos", "Evento", "Paquetes", "Extras", "Resumen"];
